import './content.scss'
import cpanel from './images/cpanel.png'
import secured from './images/secured.png'
import litespeed from './images/litespeed.png'
import soft from './images/soft.png'
import wordpress from './images/wordpress.png'
import cloudflare from './images/cloudflare.png'

function Content() {
    return (
        <div className='content'>
            <div className='info'>
                <h2 className='info__header'>
                    True Cloud Web  Hosting
                </h2>
                <div className='info__description'>
                    True Cloud Web Hosting All of the hosting packages we offer are deployed instantly
                    on our SSD powered cloud. We don’t use dedicated servers that operate on single pieces
                    of hardware. Our entire infrastructure is built to be reliable, secure, and scalable.
                </div>
            </div>
            <div className='content__products'>
                <div className='row'>
                    <img src={cpanel} alt='cpanel' className='solutions'/>
                    <img src={secured} alt='secured' className='solutions'/>
                    <img src={litespeed} alt='litespeed' className='solutions'/>
                </div>
                <div className='row'>
                    <img src={soft} alt='soft' className='solutions'/>
                    <img src={wordpress} alt='wordpress' className='solutions'/>
                    <img src={cloudflare} alt='cloudflare' className='solutions'/>
                </div>
            </div>
        </div>
    )
}

export default Content
